import * as React from "react";
import { isModifiedClickEvent } from "@grandvisionhq/lib-utils-w3c";
import { useRoutingContext } from "../../context/context/RoutingContext.js";
const defaultOptions = { preventDefault: true };
function useLink(config, options) {
  const opt = { ...defaultOptions, ...options };
  const { format, router } = useRoutingContext();
  const href = format(config);
  const clickHandler = React.useCallback(
    (e) => {
      if (e && isModifiedClickEvent(e)) {
        return;
      }
      if (opt.preventDefault) {
        e?.preventDefault();
      }
      if (!href) {
        return;
      }
      if (opt.replace) {
        router.replace(href);
      } else {
        router.push(href);
      }
    },
    [opt.preventDefault, opt.replace, href, router]
  );
  if (!href) {
    return null;
  }
  return { href, onClick: clickHandler };
}
export {
  useLink
};
//# sourceMappingURL=use-link.js.map
